import React, { useContext, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Bread from "../../common/Bread";
import "../Branch/branch.scss";
import BranchMap from "../../components/BranchMap";
import Loader from "../../common/Loader";
import ATMList from "../../components/ATMList";
import { LangContext } from "../../context/LangContext";

const ATM = () => {
  const [selected, setSelected] = useState({ id: null, lat: null, lng: null });
  const { state } = useContext(LangContext);
  const nep = state.np; // true if Nepali is active

  const handleReset = () => setSelected({ id: null, lat: null, lng: null });
  const callbackSelect = ({ id, lat, lng }) => setSelected({ id, lat, lng });

  const breadcrumList = {
    image: "",
    title: nep ? "ATM स्थानहरू" : "ATM Locations",
    l1: nep ? "होम" : "Home",
    l2: nep ? "ATM" : "ATMs",
    l3: "",
  };

  const { isLoading, isFetching, error, data } = useQuery({
    queryKey: ["atmData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/atm`)
        .then((res) => res.data),
  });

  if (isLoading || isFetching) return <Loader />;
  if (error) return "An error has occurred: " + error.message;

  // Map language-specific fields
  const atmData = data?.branch?.en.map((item) => ({
    ...item,
    PageTitle: nep ? item.PageTitleNepali : item.PageTitle,
    Manager: nep ? item.ManagerNepali : item.Manager,
    Phone: nep ? item.PhoneNepali : item.Phone,
    POB: nep ? item.POBNepali : item.POB,
    mobile: nep ? item.mobile_nepali || item.mobile : item.mobile,
  }));

  const insideATM = atmData?.filter(
    (i) => i.Location.toLowerCase() === "inside",
  );
  const outsideATM = atmData?.filter(
    (i) => i.Location.toLowerCase() === "outside",
  );

  return (
    <Bread data={breadcrumList}>
      <Tabs className="branchesPageTabContainer" defaultIndex={0}>
        <TabList className="branchesPageTabsButtonContainer">
          <Tab className="branchesPageTabButton" onClick={handleReset}>
            {nep ? "काठमाडौं उपत्यका भित्र" : "Inside Kathmandu Valley"}
          </Tab>
          <Tab className="branchesPageTabButton" onClick={handleReset}>
            {nep ? "उपत्यका बाहिर" : "Outside Valley"}
          </Tab>
        </TabList>

        <TabPanel>
          <div className="branchesPageContainer">
            <ATMList data={insideATM} callbackSelect={callbackSelect} />
            <div className="branchesMapContainer">
              <BranchMap data={insideATM} selected={selected} />
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="branchesPageContainer">
            <ATMList data={outsideATM} callbackSelect={callbackSelect} />
            <div className="branchesMapContainer">
              <BranchMap data={outsideATM} selected={selected} />
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </Bread>
  );
};

export default ATM;
